import axiosInstance from '../axiosInterceptor/axiosInstance'

const inviteUsers = async ({ orgId, invitations }) =>
  axiosInstance.post(`v1/orgs/${orgId}/invitations`, { invitations })

export default inviteUsers
